import http from './client';

const encryptedValue = ''; // Replace with value you'd like to decrypt
export async function test() {
  const response = await http.post('test', {
    encryptedValue,
  });
  console.log(response.data);
}
